import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export interface AddRoleScreen {
    role_id: number,
    screen_ids: [
        string
    ]
}

export const AddRolesScreenSlice = createSlice({
    name: "AddRolesScreen",
    initialState: {} as IReduxState<AddRoleScreen>,
    reducers: {
        getAddRolesScreen: (state, _: PayloadAction<AddRoleScreen>) => {
            state.isLoading = true;
        },
        successAddRolesScreen: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureAddRolesScreen: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearAddRolesScreen: (state) => {
            state.data = {};
        },
    },
});

export const {
    getAddRolesScreen,
    successAddRolesScreen,
    failureAddRolesScreen,
    clearAddRolesScreen,
} = AddRolesScreenSlice.actions;

export default AddRolesScreenSlice.reducer;
